import { render } from "./ChipsCategory.vue?vue&type=template&id=133960f8"
import script from "./ChipsCategory.vue?vue&type=script&lang=js"
export * from "./ChipsCategory.vue?vue&type=script&lang=js"

import "./ChipsCategory.vue?vue&type=style&index=0&id=133960f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__